import { Link } from 'react-router-dom';
import { CarouselPrimary, InputSearchGray, Layout, LearningGrid } from '../../components';
import DynamicFaIcon from '../../components/atoms/DynamicFaIcon';
import CategoryLearning from '../../components/moleculs/CategoryLearning';
import { useEffect } from 'react';

const Home = () => {

    useEffect(() => {

    }, [])

    return (
        <Layout showNavBar={false} showNavigation={true}>
            <div className='mt-5 mb-[7rem] min-h-screen overflow-auto'>
                <div className="flex gap-5 justify-between items-center ">
                    <InputSearchGray icon={'FaSistrix'} placeholder='Cari Judul Training' />
                    <button>
                        <DynamicFaIcon name={"FaBell"} />
                    </button>
                </div>
                <div className='my-3'>
                    <CarouselPrimary />
                </div>
                <div className='mt-[2rem'>
                    <h2 className='text-[12px] font-medium mb-5'>Kategori</h2>
                    <CategoryLearning />
                </div>
                <div className='mt-[2rem]'>
                    <div className='flex justify-between mb-3'>
                        <h2 className='text-[12px] font-medium'>Taining</h2>
                        <Link className='text-[12px]' to={'/admin/learning'}>Lihat Semua</Link>
                    </div>
                    <LearningGrid />
                </div>
            </div>
        </Layout>
    );
};

export default Home;